<template>
	<div class="d-flex app-wrapper">

		<!-- MODAL DE CONVITE -->
		<modal v-if="showModal" class="modal-invited" @close="showModal = false">
		<div slot="header">
			<div class="tit float-left">
			<h2>
				<i class="icon icon-airplane xl"></i>
				Enviar Convite
			</h2>
			</div>
		</div>

		<div slot="body">
			<section class="row">
				<!-- <div class="col-12 col-md-3">
				<a href="#" class="btn btn-primary invited-person active" @click="modalStep = 1, activeButton('person'), auxModalStep = 1">
					Convidar amigo
				</a>
				</div> -->
				<div class="col-12 col-md-3">
				<a href="#" class="btn btn-primary invited-company" @click="modalStep = 2, activeButton('company'), auxModalStep = 2">
					Convidar empresa
				</a>
				</div>
			</section>
			<section class="row">
				<div class="col-12">
					<h3>
					Convite por email
					</h3>
				<!-- FORMULARIO CONVIDAR AMIGO -->
				<friend v-if="modalStep === 1" v-on:finished="finishInvite()"/>
				<!-- :::::::::::: -->
				<!-- FORMULARIO CONVIDAR EMPRESA -->
				<company v-else-if="modalStep === 2" v-on:finished="finishInvite()" />
				<!-- ::::::::::::: -->
				<!-- STEP DE MENSAGEM ENVIADA DE SUCESSO -->
				<div v-else-if="modalStep === 3" class="success d-flex flex-column justify-content-center align-items-center">
					<i class="icon icon-success xll"></i>
					<h3>
					Seu convite foi enviado com sucesso!
					</h3>
					<a href="javascript:;" v-on:click.prevent="modalStep = auxModalStep" class="btn btn-primary">
					enviar novamente
					</a>
				</div>
				<!-- ::::::::::::::::: -->
				</div>
			</section>
		</div>
		</modal>
		<!-- ::::::::::: -->

			<!-- MODAL ALTERNAR INVESTIMENTO -->
		<div class="modal modal__bootstrap fade" id="modalMotivo" tabindex="-1" role="dialog" aria-labelledby="modalMotivo" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal__bootstrap-header">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal__bootstrap-body">
						<div>
							<h2>Ir para empréstimos</h2>
							<img src="/static/assets/images/investidor.svg" class="image" alt="">
							<p>Você está prestes a ir para a área de <strong>Solicitação de empréstimos</strong>. Tem certeza que deseja mudar de ambiente?</p>
							<button class="btn btn-lg btn-secondary" data-dismiss="modal" aria-label="Close">Continuar em Investimentos</button>
							<router-link to='/emprestimos/meus-emprestimos' class="btn btn-lg btn-primary" data-dismiss="modal">Solicitar um empréstimo <img src="/static/assets/images/seta-modal.svg" width="16"></router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- FINAL MODAL ALTERNAR INVESTIMENTO -->

		<SideMenu :items="menuItems" :tipo="'investimentos'" />

		<div class="bg"></div>

		<div class="wrapper d-flex flex-column">
		<header class="head row d-flex justify-content-between">
			<div class="col-12 col-md-5 col-lg-5 iouu" v-bind:class="{mobHide: !InvestidorComInvestimento()}">
				<a href="/" class="link" title="IOUU">
					<i class="ico-iouu" />
				</a>
				<p><span>Seja bem-vindo à plataforma IOUU</span> Esse é seu dashboard. Aqui você poderá criar seu portfólio de investimentos, acompanhar seus ganhos e ficar por dentro das novidades da IOUU.</p>
			</div>

			<div class="col-12 col-md-5 col-lg-7">
			<!-- MENU TOP HEADER MOBILE -->
			<div class="d-flex justify-content-between util mob" v-bind:class="{resetPad: !InvestidorComInvestimento()}">
				<div class="mob-menu">
				<a @click="ShowMobMenu(true);" class="btn">
					<i class="fas fa-bars"></i>
				</a>
				</div>
				<div class="mob-logo">
					<a href="/" class="link" title="IOUU">
						<i class="ico-iouu" />
					</a>
				</div>
				<div class="mob-profile">
				<!-- ALERTA MOBILE -->
				<alerts :from="from" tipoUsuario="investimentos"></alerts>
				<!-- ::::::::::::: -->
				<div class="user">
					<at-dropdown placement="bottom-right">
					<router-link :to="{ path: '/investimentos/perfil/configuracoes' }" tag="div">
					<div class="no-image rounded-circle">{{LetraNome()}}</div>
					</router-link>
					</at-dropdown>
					
					<div class="exit">
					<a href="#" title="Sair" v-on:click='Logout'><i class="ico-exit"></i></a>
					</div>
				</div>
				</div>
			</div>
			<!-- ::::::::::::::: -->

			<!-- MENU TOP HEADER DESKTOP -->
			<div class="d-flex justify-content-end util">
				<div class="invite" style="">
				<!-- <a href="/#/investimentos/convidar-amigo" title="Convidar amigo"><i class="ico-ps-2"></i> Indique um amigo e ganhe <strong>R$</strong></a> -->
				<!-- <a href="#" id="show-modal" @click="showModal = true" title="Convidar amigo"><i class="ico-ps-2"></i> Convidar amigo</a> -->
				</div>

				<!-- ALERTA MOBILE -->
				<alerts :from="from" :tipoUsuario="'investimentos'"></alerts>
				<!-- ::::::::::::: -->

				<div class="user">
				<at-dropdown placement="bottom-right">
					<div class="no-image rounded-circle">{{LetraNome()}}</div>
					<span>Olá, <strong>{{Nome()}}</strong> <i class="icon icon-chevron-down"></i></span>
					<at-dropdown-menu slot="menu">
						<at-dropdown-item > <router-link :to="{ path: '/investimentos/notificacoes' }" tag="div">Minhas Notificações</router-link></at-dropdown-item>
					<at-dropdown-item > <router-link :to="{ path: '/investimentos/meus-investimentos' }" tag="div">Meus Investimentos</router-link></at-dropdown-item>
					<at-dropdown-item > <router-link :to="{ path: '/investimentos/historico' }"  tag="div">Meu Histórico</router-link></at-dropdown-item>
					<at-dropdown-item divided > <router-link :to="{ path: '/investimentos/perfil/dados-pessoais' }" tag="div">Meu Perfil</router-link></at-dropdown-item>
					</at-dropdown-menu>
				</at-dropdown>
				</div>

				<!-- CHECKOUT OPTIONS -->
				<div class="checkout" style="display: none;">
				<at-dropdown placement="bottom-right">
					<i class="ico-ct-4 align-middle"></i>
					<span class="checkout-number">3</span>

					<at-dropdown-menu slot="menu">
					<at-dropdown-item>
						<div class="drop-checkout-header">
						<i class="icon icon-wallet-2 xl"></i>
						<span>Carteira de investimentos</span>
						</div>
					</at-dropdown-item>

					<at-dropdown-item>
						<table class="table">
						<thead>
							<tr>
							<th scope="col" class="align-middle text-center">Score</th>
							<th scope="col" class="align-middle text-center">ID</th>
							<th scope="col" class="align-middle text-center">Valor do investimento</th>
							</tr>
						</thead>
						<tbody>
							<tr class="rating-aa">
							<td class="rating align-middle text-center"><span class="box rounded-circle"></span></td>
							<td scope="col" class="align-middle text-center">00001</td>
							<td scope="col" class="align-middle text-center">R$ 5.000,00</td>
							</tr>
							<tr class="rating-a">
							<td class="rating align-middle text-center"><span class="box rounded-circle"></span></td>
							<td scope="col" class="align-middle text-center">00001</td>
							<td scope="col" class="align-middle text-center">R$ 5.000,00</td>
							</tr>
							<tr class="rating-b">
							<td class="rating align-middle text-center"><span class="box rounded-circle"></span></td>
							<td scope="col" class="align-middle text-center">00001</td>
							<td scope="col" class="align-middle text-center">R$ 5.000,00</td>
							</tr>
						</tbody>
						<tfoot>
							<tr>
							<td colspan="3">
								<span>Valor total de investimentos:</span>
								<strong>R$ 12.000,00</strong>
							</td>
							</tr>
						</tfoot>
						</table>
					</at-dropdown-item>
					<at-dropdown-item divide>
						<div class="row">
						<div class="col-7">
							<router-link to="/carteira-investimento" class="my-wallet">Ver minha carteira de investimentos</router-link>
						</div>
						<div class="col-5">
							<router-link to="/finalizar-investimento" class="btn btn-primary finish">Finalizar</router-link>
						</div>
						</div>
					</at-dropdown-item>
					</at-dropdown-menu>
				</at-dropdown>
				</div>

			<!-- .news  -->
			<div class="news" v-if="InvestorAprovado">
				<a class="beamerTrigger"><i class="fas fa-fire"></i> Novidades</a>
			</div>

				<!-- :::::::: -->
				<div class="exit">
				<a href="#" title="Sair" v-on:click='Logout'><i class="ico-exit"></i> Sair</a>
				</div>
			</div>
			<!-- ::::::::::: -->
			</div>
		</header>

		<div class="row block-responses" v-if="!InvestidorComInvestimento() ">
			<div class="col-12 col-md-12 col-lg-4 col-xl-4">
			<!-- Não aprovado -->
				<p class="user" v-if="!InvestorAprovado">
					<span>{{Nome()}},</span>
					Seu perfil está quase completo
				</p>
				<p class="response" v-if="!InvestorAprovado && (!Investidor() || !Suitability())">
					Já confirmamos sua conta na IOUU e para você começar a investir, basta concluir seu cadastro de investidor e preencher o formulário de suitability.
				</p>
				<p class="response" v-if="!InvestorAprovado && Investidor() && Suitability()">
					Agora estamos analisando suas informações e retornaremos em até 1 dia útil.
				</p>

				<!-- Aprovado -->
				<p class="user" v-if="InvestorAprovado">
					<span>{{Nome()}},</span>
					Seu perfil está completo.
				</p>
				<p class="response" v-if="InvestorAprovado">
					Agora você já pode investir nas oportunidades em aberto.
				</p>
			</div>

			<div class="col-12 col-md-12 col-lg-8 col-xl-8 steps">
			<ul class="d-flex justify-content-end">
				<li class="step">
				<i class="ico ico__ok"></i>
				<p>Sua conta na IOUU está OK!</p>
				</li>
				<li class="align-self-center">
				<div class="div"></div>
				</li>
				<li class="step">
				<i class="ico" :class="Investidor() ? (this.InvestorAprovado ? ' ico__ok': ' ico__ok next') : ' ico ico__investidor' "></i>
				<p>Cadastro de Investidor</p>
				<span>
					<router-link v-if="!Investidor()" to="/informacoes-adicionais/investidor" class="btn btn-sm btn-primary" title="Preencher formulário">Preencher</router-link>
					<span v-if="!this.InvestorAprovado && Investidor()" class="btn btn-sm btn-primary" style="cursor:default">Em analise</span>
				</span>
				</li>
				<li class="align-self-center ">
				<div class="div"></div>
				</li>
				<li class="step ">
				<i class="ico" :class="Suitability() ? ' ico__ok' : ' ico ico__formulario' "></i>
				<p>Formulário de suitability</p>
				<span>
					<router-link v-if="!Suitability()" to="/informacoes-adicionais/suitabilityVerify" class="btn btn-sm btn-primary" title="Preencher formulário">Preencher</router-link>
					<span style="display:none;" class="badge badge-warning">Em analise</span>

				</span>
				</li>
				<li class="align-self-center">
				<div class="div"></div>
				</li>
				<li class="step ">
				<i class="ico ico__investir next"></i>
				<p>Apoiar primeiro projeto</p>
				<router-link v-if="this.InvestorAprovado" :to="{ name: 'Oportunidades' }" class="btn btn-sm btn-primary" title="Oportunidades">Oportunidades</router-link>
				</li>
			</ul>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
			<at-menu router mode="horizontal">
				<at-menu-item :to="{ name: 'Investimentos' }"><i class="ico-gra-4"></i>Meus investimentos</at-menu-item>
				<at-menu-item :to="{ name: 'Oportunidades' }"><i class="ico-ps"></i>Oportunidades</at-menu-item>
				<at-menu-item :to="{ name: 'Antecipacao' }"><i class="ico-gra"></i>Antecipação</at-menu-item>
				<at-menu-item :to="{ name: 'InvestimentodeImpacto' }"><i class="ico-imp"></i>Investimento Social</at-menu-item>
				<at-menu-item :to="{ name: 'CarteiraInvestimento' }"><i class="ico-ct-4"></i>Carteira Virtual</at-menu-item>
			</at-menu>
			</div>
		</div>

		<main>
			<transition name="fade" mode="out-in">
			<router-view  />
			</transition>
		</main>

		<footer class="d-flex justify-content-between">
			<div>
			<a href="/" class="link" title="IOUU">
				<i class="ico-iouu"></i>
				<span>V - {{ version }} - © 2020 - IOUU. TODOS OS DIREITOS RESERVADOS.</span>
			</a>
			</div>
			<social-network/>
		</footer>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.app-wrapper {
		position: relative;
	}
	.invited-company{
		width: 180px !important;
	}

	.news {
		display: flex;
		align-items: center;
		a {
			display: flex;
			align-items: center;
			padding-bottom: 4px;

			i {
				margin-right: 8px;
			}
		}
		@media (max-width: 575px) {
			display: none;
		}
		@media (min-width: 576px) and (max-width: 767px) {
			display: none;
		}
	}

	@media (min-width: 992px) and (max-width: 1279.95px) {
		.invite, .user, .news, .exit {
			letter-spacing: -.8px;
		}
	}
</style>

	<script>
	/* eslint-disable */
	import SocialNetwork from '@/components/SocialNetworkDashboard'
	import SideMenu from '@/components/SideMenu'
	import ApiClient from '../../utils/api-client'
	import * as mutationTypes from '@/store/mutation-types.js'
	import Modal from '@/components/Modal'
	import Friend from '@/components/Invite/Friend'
	import Company from '@/components/Invite/Company'
	import Alerts from  '@/components/Alerts'
	import pkg from '../../../package.json'

	export default {
		metaInfo: {
		htmlAttrs: {
			lang: 'pt-br'
		},
		bodyAttrs: {
			class: 'bg-light'
		}
		},

		data() {
		return {
			version: pkg.version,
			menuItems: [
			{iconClass: "ico-din-3", title: "Quero empréstimo", path: "/emprestimos/meus-emprestimos", title2: "Quero empréstimo", modal:true},
			{iconClass: "ico-gra-4", title: "Meus investimentos", path: "/investimentos/meus-investimentos"},
			{iconClass: "ico-ps", title: "Oportunidades", path: "/investimentos/oportunidades"},
			{iconClass: "ico-imp", title: "Investimentos sociais", path: "/investimentos/investimento-de-impacto"},
			{iconClass: "ico-lib", title: "Meu histórico", path: "/investimentos/historico"},
			{iconClass: "ico-ct-4", title: "Carteira virtual", path: "/investimentos/carteira-investimento" },
			// {iconClass: "ico-ct-2", title: "Portfólios", path: "/investimentos/portfolios"},
			// {iconClass: "ico-gra-3", title: "Estatísticas", path: "/investimentos/estatisticas"},
			// {iconClass: "ico-ct-4", title: "Central de cobranças", path: "/investimentos/central-de-cobranca" },
			{iconClass: "ico-ch", title: "Perguntas e respostas", url: "http://ajuda.iouu.com.br" }
			],
			InvestorAprovado: false,
			TemInvestimento: false,
			showModal: false,
			modalStep: 1,
			auxModalStep: 1,
			from: "ENV",
		}
		},

		components: {
		SideMenu,
		SocialNetwork,
		Modal,
		Friend,
		Company,
		Alerts
		},

		methods: {
		Investidor() {
			window.variavel = this
			if (this.User.hasinvestor == undefined)
			return false;
			return this.User.hasinvestor;
		},

		Suitability() {
			if (this.User.hassuitability == undefined)
			return false;
			return this.User.hassuitability;
		},

		Logout() {
			this.$store.dispatch('logout')
			this.$router.push('/login')
		},

		Nome() {
			var nome = "",
			letra = "";
			if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
			nome = this.User.username;
			} else {
			nome = this.User.name;
			}
			nome = nome.trim();
			var primeiroNome = nome.split(" ")[0];
			return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
		},

		LetraNome() {
			var nome = this.Nome();
			if (nome != null && nome != undefined && nome.length > 0)
			return nome[0].toUpperCase()
			return "";
		},

		InvestidorComInvestimento() {
			return this.User.hasinvestments;
		},

		// METHOD TO SHOW MOBILE MENU
		ShowMobMenu(status) {
		var menu = document.getElementsByClassName('collapsed-menu');
		if(status == true && menu.length >= 1) {
			menu[0].classList.add("show");
		}
		},

		finishInvite() {
		this.modalStep = 3;
		},

		activeButton(name) {
		var
			buttonName = name;

			if(buttonName === "person") {
				document.getElementsByClassName('invited-person')[0].classList.add('active');
				document.getElementsByClassName('invited-company')[0].classList.remove('active');
			} else {
				document.getElementsByClassName('invited-person')[0].classList.remove('active');
				document.getElementsByClassName('invited-company')[0].classList.add('active');
			}
		}
		},

		computed: {
		User: function() {
			return this.$store.state.currentUser;
		},

		created: function(){
			this.$store.commit(mutationTypes.START_LOADING)
			ApiClient.getInvestor()
			.then(investor => {
				console.log(investor)
				this.InvestorAprovado = investor.Status == "APROVADO";
				this.$store.commit(mutationTypes.STOP_LOADING);
			})
			.catch(() => this.$store.commit(mutationTypes.STOP_LOADING))
		}
		},

		created: function() {

		this.$store.commit(mutationTypes.START_LOADING)

		if(sessionStorage.getItem("redirectINV") == null)
		{
				sessionStorage.setItem("redirectINV","true");
		

			if(this.User.tipo != null && this.User.tipo.length > 0 && this.User.tipo[0] == "TOM"){
				this.$store.commit(mutationTypes.STOP_LOADING)
				window.location.href= "/#/emprestimos/meus-emprestimos"
				return;
			}
			else {
				this.$store.commit(mutationTypes.STOP_LOADING)
				window.location.href= "/#/investimentos/meus-investimentos"
				return;
				// this.$store.commit(mutationTypes.START_LOADING)
				// ApiClient.getInvestor()
				//   .then(investor => {
				//     this.InvestorAprovado = investor.Status == "APROVADO";
				//   })
				//   .finally(() => this.$store.commit(mutationTypes.STOP_LOADING))
			}
		}
		else
		{

		

		ApiClient.getInvestor()

			.then(investor => {
			this.InvestorAprovado = investor.Status == "APROVADO";

			

			})
			.finally(() => this.$store.commit(mutationTypes.STOP_LOADING))

		}

	}, beforeCreate() {

		window.document.title= 'Dashboard IOUU';
		
	}
	}
	</script>



// WEBPACK FOOTER //
// src/views/layouts/ApplicationLayout.vue